import React from 'react';
import { Wallet } from 'lucide-react';
interface BalanceCardProps {
  balance: number;
  savings: number;
}
export function BalanceCard({
  balance,
  savings
}: BalanceCardProps) {
  const formatMoney = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(amount);
  };
  return <div className="w-full bg-gradient-to-br from-stone-800 to-stone-900 rounded-3xl p-6 shadow-xl shadow-black/20 border border-stone-800 relative overflow-hidden" data-id="element-19">
      <div className="absolute -top-12 -right-12 w-40 h-40 bg-amber-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-20" />

      <div className="relative z-10" data-id="element-21">
        <div className="flex items-center gap-2 mb-2" data-id="element-22">
          <Wallet className="text-amber-500" size={20} data-id="element-23" />
          <span className="text-stone-400 text-sm font-medium uppercase tracking-wider" data-id="element-24">
            Total Balance
          </span>
        </div>
        <h2 className="text-4xl font-bold text-stone-50 mb-6" data-id="element-25">
          {formatMoney(balance)}
        </h2>

        <div className="bg-stone-900/50 rounded-2xl p-4 border border-stone-800/50" data-id="element-26">
          <div className="flex items-center gap-2 mb-1" data-id="element-27">
            <Wallet className="text-emerald-500" size={16} data-id="element-28" />
            <span className="text-stone-400 text-xs uppercase tracking-wide" data-id="element-29">
              Total Savings
            </span>
          </div>
          <p className="text-emerald-400 font-bold text-xl" data-id="element-30">
            {formatMoney(savings)}
          </p>
        </div>
      </div>
    </div>;
}